/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class BranchField extends React.PureComponent {
  render() {
    const { disabled, value, branches, onChange } = this.props

    const options = branches.map(branch => ({
      key: branch.key || branch.id,
      value: branch.key || branch.id,
      text: branch.name,
    }))

    return (
      <Form.Select
        required
        fluid
        options={options}
        label="Branch"
        placeholder="Please choose branch"
        onChange={(e, data) => onChange(data.value)}
        value={value}
        disabled={disabled}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/branchField.js